import { FALLBACK_CHNL_ICON_URL, LOCAL_DEFAULT_PACKAGES } from "./fallBackData";
import { getSignaturePackagesForLocalChannel, isChannelsServiceLocal, isServiceLocalInPackage } from "lib/service/channels/get-local-national-dma-eligible-channels";

const getRsnTeams = channel => {
  const teams = [];
  if (channel?.nba) {
    const nbaTeams = channel.nba?.split(",") || [];
    nbaTeams.forEach(team => {
      teams.push(team.trim());
    })
  }
  if (channel?.mlb) {
    const mlbTeams = channel.mlb?.split(",") || [];
    mlbTeams.forEach(team => {
      teams.push(team.trim());
    })
  }
  if (channel?.nhl) {
    const nhlTeams = channel.nhl?.split(",") || [];
    nhlTeams.forEach(team => {
      teams.push(team.trim());
    })
  }
  if (channel?.mls) {
    const mlsTeams = channel.mls?.split(",") || [];
    mlsTeams.forEach(team => {
      teams.push(team.trim());
    })
  }
  if (channel?.wnba) {
    const wnbaTeams = channel.wnba?.split(",") || [];
    wnbaTeams.forEach(team => {
      teams.push(team.trim());
    })
  }
  return teams.join(", ");
}

const getFormattedChannels = (channels, category, data) => {
  const { genreLocalChannelMapping = {}, zipcodeDma = '', selectedGenres, rsnTierLegalText = {}, genreNationals = {}, signatureExcludedLocalChannels } = data || {};
  return channels?.map(chnl => {
    // Generated by Copilot- Start - 2026-04-23 09:00:00
    // Get signature packages for this channel, excluding per-package if configured
    let localPackageListSystem = category?.toLowerCase?.() === "local" ?
      getSignaturePackagesForLocalChannel(chnl?.network, zipcodeDma, LOCAL_DEFAULT_PACKAGES || [], signatureExcludedLocalChannels, chnl) :
      (LOCAL_DEFAULT_PACKAGES || []);
    // Generated by Copilot- End - 2026-04-23 09:00:00
    let isNationalFlag = false;
    let nationalPackageListSystem = [];
    if (category?.toLowerCase?.() === "local") {
      // A channels-service station (WAT-11611) is placed by its own package list, not the CMS mapping.
      const isServiceStation = isChannelsServiceLocal(chnl);
      if (isServiceStation) {
        selectedGenres?.forEach(val => {
          if (isServiceLocalInPackage(chnl, val?.id)) {
            localPackageListSystem = [...localPackageListSystem, val?.id];
          }
        });
      }
      const filteredChnl = isServiceStation ? undefined : genreLocalChannelMapping?.find(item => item?.channel === chnl?.network);
      if (filteredChnl) {
        Object.entries(filteredChnl).forEach(([key, value]) => {
          if (typeof value === 'string' && value.includes(zipcodeDma)) {
            selectedGenres?.forEach(val => {
              if (val?.queryparam === key) {
                localPackageListSystem = [...localPackageListSystem, val?.id];
              }
            });
          }
        });
      }
    }
    if (category?.toLowerCase?.() === "national") {
      if (Object.keys(genreNationals).length > 0) {
        const { genreNationalMapping } = genreNationals || {};
        genreNationalMapping?.forEach(ntl => {
          selectedGenres?.forEach(val => {
            if (chnl?.network === ntl?.channel && ntl[val?.queryparam]?.includes(zipcodeDma)) {
              isNationalFlag = true;
              nationalPackageListSystem = [...nationalPackageListSystem, val?.id || val?.packageId];
            }
          });
        });
      }
    }
    const channelData = {
      tunerPosition: chnl?.channelNumber,
      channelLogoPath: chnl?.logo ?
        chnl?.logo.includes("directv.com") ?
          chnl?.logo :
                    `https://www.directv.com${chnl?.logo?.startsWith("/") ? "" : "/"}${chnl?.logo}` :
        FALLBACK_CHNL_ICON_URL,
      channelNameLabel: chnl?.network,
      categoryId: isNationalFlag ? 'National' : category,
      ...(category?.toLowerCase?.() === "national" && {
        packageListSystem: isNationalFlag ?
          [...(localPackageListSystem || []), ...nationalPackageListSystem] :
          nationalPackageListSystem
      }),
      ...(category?.toLowerCase?.() === "local" && { packageListSystem: isNationalFlag ? nationalPackageListSystem : localPackageListSystem }),
      ...(category?.toLowerCase?.() === "rsn" && {
        teamNames: getRsnTeams(chnl),
        packageListSystem: chnl?.packageNames || [],
        rsnTierLegal: rsnTierLegalText?.[`tier${  chnl?.rsntier}`] || ''
      })
    };
    return channelData;
  });
};

export const getChannelsData = async (channelsData, selectedPackages, packageConfig, otherData) => new Promise(resolve => {
  try {
    const {
      accordionGenrePackBackgroundColor = "#A4C9F5",
      accordionGenrePackColor = "#102641",
      channelsAccordionName = "Channels",
      channelsAccordionTextColor = "#102641",
      channelsAccordionBackgroundColor = "#ECF3FB",
      expand,
      zipcodeDma = "",
      rsnTierLegalText = {},
      genreLocalChannelMapping,
      genreNationals,
      maxColumns,
      channelCountsLabel,
      columnSelections,
      miniSelectionsByColumn
    } = otherData || {};

    const selectedPkgIds = selectedPackages.map(pkg => pkg.id);

    // Local/National/RSN logic
    const { localChannels, rsnChannels } = channelsData?.localRsnChannels || {};
    const tempNationalChannels = getFormattedChannels(localChannels || [], "National", {
      genreLocalChannelMapping,
      zipcodeDma,
      selectedGenres: selectedPackages,
      genreNationals
    });
    const nationalChannels = tempNationalChannels?.filter(chnl => chnl?.packageListSystem?.length > 0);
    const tempRsnChannels = getFormattedChannels(rsnChannels, "RSN", { rsnTierLegalText });
    // Generated by Copilot- Start - 2026-04-27 09:00:00
    // Drop locals with empty packageListSystem after exclusion (e.g. Telemundo
    // blanket-excluded from all signature pkgs and not in any genre pack for this DMA).
    const rawLocalChannels = getFormattedChannels(localChannels, "Local", {
      genreLocalChannelMapping,
      zipcodeDma,
      selectedGenres: selectedPackages,
      genreNationals,
      signatureExcludedLocalChannels: otherData?.signatureExcludedLocalChannels
    }) || [];

    let tempLocalChannels = rawLocalChannels
      .filter(chnl => chnl?.packageListSystem?.length > 0);
    // Generated by Copilot- End - 2026-04-27 09:00:00
    if (nationalChannels && nationalChannels.length > 0) {
      tempLocalChannels = [...tempLocalChannels, ...nationalChannels];
    }

    // Combine all channels (main, RSN, local/national)
    const allChannels = [
      ...(channelsData?.channels || []),
      ...(tempRsnChannels || []),
      ...tempLocalChannels
    ];

    // Separate MyFree DTV channels from the rest
    // MyFree accordion: channels that have MYFREE_DTV in their packageListSystem
    const myFreeDtvChannels = allChannels.filter(chnl => {
      if (!Array.isArray(chnl?.packageListSystem)) {
        return false;
      }
      return chnl.packageListSystem.some(pkg => typeof pkg === 'string' && pkg.includes("MYFREE_DTV"));
    });
    // Main channel list: channels carrying NO MYFREE_DTV package. A MyFree channel
    // renders only under the MyFree accordion, even when the feed also associates it
    // with a genre or signature pack. This reverses the earlier rule that kept
    // dual-membership channels (e.g. BBC News) in the regular grid as well.
    const nonMyFreeChannels = allChannels.filter(chnl => {
      if (!Array.isArray(chnl?.packageListSystem)) {
        return true;
      }
      return !chnl.packageListSystem.some(pkg => typeof pkg === 'string' && pkg.includes("MYFREE_DTV"));
    });

    // Filter channels: only keep channels that belong to at least one selected package
    const filteredChannels = nonMyFreeChannels.filter(chnl => {
      if (!Array.isArray(chnl.packageListSystem)) {
        return false;
      }
      if (chnl.categoryId?.toLowerCase() === "rsn") {
        return selectedPkgIds.some(pkgId => {
          const pkgSuffix = pkgId.split('TV_').pop(); // "CHOICE" from "ATT_TV_CHOICE"
          return chnl.packageListSystem.some(p => typeof p === 'string' && p === pkgSuffix);
        });
      }
      // Generated by Copilot- Start - 2026-03-23 16:38:39
      // Use exact match (===) instead of .includes() to prevent
      // substring false positives (e.g. ATT_TV_MYSPORTSBETA matching ATT_TV_MYSPORTS)
      return selectedPkgIds.some(pkgId => chnl.packageListSystem.some(p => typeof p === 'string' && p === pkgId));
      // Generated by Copilot- End - 2026-03-23 16:38:39
    });

    // Remove duplicates by channelNameLabel. Rows arrive main -> RSN -> local/national, and the
    // LAST row supplies every field except packageListSystem (notably categoryId, which picks the
    // bucket, the label and RSN-suffix matching). WAT-12561: rows of the same kind (main feed,
    // local, national or RSN) union their packages, so a package split over two main-feed rows
    // keeps its check. Rows of different kinds keep last-row-wins: local packages are DMA-filtered
    // and RSN rows store package suffixes, so a cross-kind union would re-add excluded checks.
    const rowKind = (c: any) => {
      const cat = c?.categoryId?.toLowerCase?.();
      return cat === "local" || cat === "national" || cat === "rsn" ? cat : "main";
    };
    const uniqueChannelsMap = {};
    filteredChannels.forEach(chnl => {
      const name = chnl?.channelNameLabel;
      if (name) {
        const prev = uniqueChannelsMap[name];
        const prevPkgs = prev && rowKind(prev) === rowKind(chnl) ? (prev?.packageListSystem ?? []) : [];
        const mergedPkgs = [...prevPkgs, ...(chnl?.packageListSystem ?? [])];
        uniqueChannelsMap[name] = {
          ...chnl,
          packageListSystem: [...new Set(mergedPkgs)]
        };
      }
    });
    const uniqueChannels = Object.values(uniqueChannelsMap);

            // For each channel, set indicators for selected packages
            type ChannelType = {
                channelNameLabel?: string;
                packageListSystem?: string[];
                categoryId?: string;
                teamNames?: string;
                rsnTierLegal?: string;
                label?: string;
            };
            const channelCountsRow = {
              channelName: channelCountsLabel,
              indicators: Array.from({ length: maxColumns || 3 }).map((_, i) => {
                const colSel = columnSelections[i] || {};
                const genreIds = colSel.genre || [];
                const signatureIds = colSel.signature || [];
                const miniIds = miniSelectionsByColumn && miniSelectionsByColumn[i] ? miniSelectionsByColumn[i] : [];
                const allPkgIds = [...genreIds, ...signatureIds, ...miniIds];

                // Find all packages in packageConfig that match these IDs
                const pkgs = (packageConfig || []).filter(pkg => allPkgIds.some(id => pkg.id?.toUpperCase() === id.toUpperCase()));

                // Sum up the counts for all packages in this column
                let totalCount = 0;
                let signLetter = "";
                pkgs.forEach(pkg => {
                  const count = Number(pkg.channel?.displayCount || pkg.channel?.count || 0);
                  totalCount += isNaN(count) ? 0 : count;
                  if (!signLetter && pkg.channel?.signLetter) {
                    signLetter = pkg.channel.signLetter;
                  }
                });

                // If no packages, return empty string
                if (pkgs.length === 0) {
                  return "";
                }
                // If any package has a "+", use it (or use signLetter from the first found)
                return (totalCount ? totalCount : "") + (signLetter || "");
              }),
              category: "channelCount"
            };
            while (channelCountsRow.indicators.length < (maxColumns || 3)) {
              channelCountsRow.indicators.push('-');
            }
            const buildRow = (chnl: ChannelType) => {
              const indicators = [];
              const indicatorLabels = [];
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < (maxColumns || 3); i++) {
                // Get all package IDs for this column (genre, signature, mini)
                const colSel = columnSelections[i] || {};
                const genreIds = colSel.genre || [];
                const signatureIds = colSel.signature || [];
                const miniIds = miniSelectionsByColumn && miniSelectionsByColumn[i] ? miniSelectionsByColumn[i] : [];
                let allPkgIds = [...genreIds, ...signatureIds, ...miniIds];
                if (chnl.categoryId?.toLowerCase() === "rsn") {
                  allPkgIds = allPkgIds.map(id => {
                    const arr = id.split('TV_');
                    return arr[arr.length - 1];
                  });
                }
                // Check if channel is included in any package for this column
                // Use includes() for non-RSN to match the filteredChannels filter logic
                // RSN channels use exact match after splitting on 'TV_'
                let found = false;
                const matchedPkgNames: string[] = [];
                if (Array.isArray(chnl?.packageListSystem)) {
                  if (chnl.categoryId?.toLowerCase() === "rsn") {
                    allPkgIds.forEach((pkgId, pkgIdx) => {
                      const matches = chnl.packageListSystem.some(p => typeof p === 'string' && p.toUpperCase() === pkgId.toUpperCase());
                      if (matches) {
                        found = true;
                        // Resolve display name from original (un-split) ID
                        const originalIds = [...(colSel.genre || []), ...(colSel.signature || []), ...(miniIds || [])];
                        const origId = originalIds[pkgIdx] || pkgId;
                        const pkg = (packageConfig || []).find(p => p.id?.toUpperCase() === origId.toUpperCase() || p.queryparam?.toUpperCase() === origId.toUpperCase());
                        matchedPkgNames.push(pkg?.displayLabel || pkg?.packageName || origId);
                      }
                    });
                  } else {
                    // Generated by Copilot- Start - 2026-03-23 16:38:39
                    allPkgIds.forEach(pkgId => {
                      // Use exact match to prevent substring false positives
                      const matches = chnl.packageListSystem.some(p => typeof p === 'string' && p.toUpperCase() === pkgId.toUpperCase());
                      // Generated by Copilot- End - 2026-03-23 16:38:39
                      if (matches) {
                        found = true;
                        const pkg = (packageConfig || []).find(p => p.id?.toUpperCase() === pkgId.toUpperCase() || p.queryparam?.toUpperCase() === pkgId.toUpperCase());
                        matchedPkgNames.push(pkg?.displayLabel || pkg?.packageName || pkgId);
                      }
                    });
                  }
                }
                const indicator = found ? 1 : null;
                indicators.push(indicator);
                indicatorLabels.push(found ? matchedPkgNames.join(", ") : "");
              }

              // Pad indicators if needed
              while (indicators.length < (maxColumns || 3)) {
                indicators.push('');
              }

              return {
                channelName: chnl.channelNameLabel,
                indicators,
                indicatorLabels,
                category: chnl.categoryId || "",
                ...(chnl?.categoryId?.toLowerCase() === "rsn" && {
                  teamNames: chnl?.teamNames,
                  rsnTierLegal: chnl?.rsnTierLegal
                }),
                ...(chnl?.categoryId?.toLowerCase() === "local" && { label: "Local" }),
                ...(chnl?.categoryId?.toLowerCase() === "national" && { label: "National" }),
                ...(chnl?.categoryId?.toLowerCase() === "rsn" && { label: "RSN" })
              };
            };

            const channelRows = (() => {
              // Separate channels by category
              const localChannelsArr = (uniqueChannels as ChannelType[])
                .filter((chnl: ChannelType) => chnl.categoryId?.toLowerCase() === "local" || chnl.categoryId?.toLowerCase() === "national")
                .sort((a, b) => (a.channelNameLabel || '').localeCompare(b.channelNameLabel || ''));

              const rsnChannelsArr = (uniqueChannels as ChannelType[])
                .filter((chnl: ChannelType) => chnl.categoryId?.toLowerCase() === "rsn")
                .sort((a, b) => (a.channelNameLabel || '').localeCompare(b.channelNameLabel || ''));
              const otherChannelsArr = (uniqueChannels as ChannelType[])
                .filter((chnl: ChannelType) => chnl.categoryId?.toLowerCase() !== "local" &&
                        chnl.categoryId?.toLowerCase() !== "rsn" &&
                        chnl.categoryId?.toLowerCase() !== "national")
                .sort((a, b) => (a.channelNameLabel || '').localeCompare(b.channelNameLabel || ''));
              return [
                channelCountsRow,
                ...localChannelsArr.map(buildRow),
                ...rsnChannelsArr.map(buildRow),
                ...otherChannelsArr.map(buildRow)
              // Keep special rows (e.g. channelCount) and only include channel rows that have at least one indicator
              ].filter(row => (
                row.category === "channelCount" ||
                  (Array.isArray(row.indicators) && row.indicators.some((ind: any) => ind === 1))
              ));
            })();

            // Build MyFree DTV accordion (separate section at the bottom)
            // MyFree channels are available with all packages, so show a checkmark for any column that has a selected package
            const buildMyFreeRow = (chnl: ChannelType) => {
              const indicators = [];
              const indicatorLabels = [];
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < (maxColumns || 3); i++) {
                const colSel = columnSelections[i] || {};
                const genreIds = colSel.genre || [];
                const signatureIds = colSel.signature || [];
                const miniIds = miniSelectionsByColumn && miniSelectionsByColumn[i] ? miniSelectionsByColumn[i] : [];
                const allPkgIds = [...genreIds, ...signatureIds, ...miniIds];
                const hasSelection = allPkgIds.length > 0;
                indicators.push(hasSelection ? 1 : null);
                // Resolve display names for all selected packages in this column
                const pkgNames = allPkgIds.map(pkgId => {
                  const pkg = (packageConfig || []).find(p => p.id?.toUpperCase() === pkgId.toUpperCase() || p.queryparam?.toUpperCase() === pkgId.toUpperCase());
                  return pkg?.displayLabel || pkg?.packageName || pkgId;
                });
                indicatorLabels.push(hasSelection ? pkgNames.join(", ") : "");
              }
              while (indicators.length < (maxColumns || 3)) {
                indicators.push('');
                indicatorLabels.push('');
              }
              return {
                channelName: chnl.channelNameLabel,
                indicators,
                indicatorLabels,
                category: chnl.categoryId || ""
              };
            };
            const myFreeDtvRows = (myFreeDtvChannels as ChannelType[])
              .sort((a, b) => (a.channelNameLabel || '').localeCompare(b.channelNameLabel || ''))
              .map(buildMyFreeRow);

            const myFreeDtvAccordion = myFreeDtvRows.length > 0 ? {
              accordionType: "Channels",
              packgeId: "MYFREE_DTV",
              expand: false,
              accordionHeading: {
                content: "MyFree DIRECTV",
                color: accordionGenrePackColor,
                backgroundColor: accordionGenrePackBackgroundColor
              },
              accordionDetails: [
                { row: myFreeDtvRows }
              ]
            } : null;

            resolve({
              channels: {
                accordionType: "Channels",
                packgeId: "allChannels",
                expand,
                accordionHeading: {
                  content: channelsAccordionName,
                  color: channelsAccordionTextColor,
                  backgroundColor: channelsAccordionBackgroundColor
                },
                accordionDetails: [
                  { row: channelRows }
                ]
              },
              ...(myFreeDtvAccordion && { myFreeDtvAccordion })
            });
  } catch (_error) {
    resolve({
      channels: {
        accordionType: "Channels",
        packgeId: "allChannels",
        expand: false,
        accordionHeading: {
          content: "Channels",
          color: "#102641",
          backgroundColor: "#ECF3FB"
        },
        accordionDetails: [
          { row: [] }
        ]
      }
    });
  }
})
